import { render } from "./factoryModel.vue?vue&type=template&id=9900e2ba&scoped=true"
import script from "./factoryModel.vue?vue&type=script&lang=js"
export * from "./factoryModel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9900e2ba"]])

export default __exports__